'use client';
import { ContentType } from '@lib/sanity/queries/modules/content/types';
import IconButton from '@ui/IconButton/IconButton';
import Text, { TextVariant } from '@ui/Text/Text';
import cn from '@utils/cn';
import useEmblaCarousel from 'embla-carousel-react';

type MobileSwiperTabType = {
  setOpenKey: (key: number) => void;
  openKey: number;
  data: ContentType;
};

function MobileTab({ data, setOpenKey, openKey }: MobileSwiperTabType) {
  const [emblaRef] = useEmblaCarousel({ dragFree: true, containScroll: 'trimSnaps' });
  if (!data.contentList) {
    return null;
  }

  function renderItem(c: NonNullable<ContentType['contentList']>[number], i: number) {
    if (!c.tabTitle?.value) {
      return null;
    }

    return (
      <div className="relative shrink-0 grow-0 basis-auto" key={i}>
        <button
          className={cn(
            'text-foreground  hover:border-border border-b',
            'cursor-pointer flex-nowrap items-start px-5 py-2',
            {
              'border-foreground hover:border-foreground cursor-default': i === openKey,
              'border-background': i !== openKey,
            },
          )}
          onClick={() => setOpenKey(i)}
        >
          <Text
            content={c.tabTitle.value}
            variant={TextVariant.SubtitleMD}
            // className={cn({ 'text-primary-foreground': i === openKey })}
          />
        </button>
      </div>
    );
  }

  return (
    <div className="w-full overflow-hidden" ref={emblaRef}>
      <div className="flex gap-2">
        {data.contentList.map(renderItem)}
        {data.tabButton?.url && (
          <IconButton className="rounded-none cursor-pointer px-5 py-2 w-auto" button={data.tabButton} variant="link" />
        )}
      </div>
    </div>
  );
}

export default MobileTab;
